export default function AlertServiceProvider() {
  this.$get = ($toast, $t) => {
    'ngInject';

    function AlertServiceProvider() {

      const self = this;

      self.success = text => showAlert(template('success', text));

      self.info = text => showAlert(template('info', text));

      self.warning = text => showAlert(template('warning', text));

      self.error = text => showAlert(template('error', text));

      self.processError = (response, defaultText) => self.error(extractError(response, defaultText));

      self.notification = notification => showNotificationAlert(notification);

      const showAlert = template => {
        $toast.show({
          controller: controller,
          template: template,
          hideDelay: 3000,
          locals: {
            notification: null
          },
          position: "top"
        });
      };

      const showNotificationAlert = notification => {
        $toast.show({
          controller: controller,
          template: '<div class="vui-toast-content vui-notification-toast">' +
            ' <div data-ng-click="ac.followNotification($event)" class="vui-toolbar-tools vui-notification-message">' +
            '   <div class="vui-notification-message__body">' +
            '     <div class="vui-notification-message__title-image">' +
            '       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '         <path d="M13.73 21C13.5542 21.3031 13.3018 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '       </svg>' +
            '     </div>' +
            '     <div class="vui-notification-message__text-group">' +
            '       <span class="vui-notification-message__text-group-title">{{ ac.notification.title }}</span>' +
            '       <span class="vui-notification-message__text-group-body" ' +
            '             data-ng-bind-html="ac.notification.message | vuiEmoji | vuiNewLines"></span>' +
            '     </div>' +
            '   </div>' +
            '   <vui-edit-btn class="close-btn" ng-click="ac.closeNotification($event)">' +
            '     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '       <path d="M19 5L5 19M5 5L19 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
            '     </svg>' +
            '   </vui-edit-btn>' +
            ' </div>' +
            '</div>',
          hideDelay: 4000,
          locals: {
            notification: notification
          },
          position: "bottom right"
        });
      }

      const template = (templateClass, text) => {
        return '<div class="vui-toast-content ' + templateClass + '">' +
          ' <div class="vui-toolbar-tools">' +
          '   <span  class="vui-toast-text">' + text + '</span>' +
          '   <vui-edit-btn class="close-btn" ng-click="ac.closeNotification($event)">' +
          '     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '       <path d="M19 5L5 19M5 5L19 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '     </svg>' +
          '   </vui-edit-btn>' +
          ' </div>' +
          '</div>';
      };

      const controller = ['$scope', '$toast', 'notification', '$rootScope',
        function AlertController($scope, $toast, notification, $rootScope) {

          $scope.ac = {
            notification: notification
          };

          $scope.ac.closeNotification = (event) => {
            event.preventDefault();
            $toast.hide();
          };

          $scope.ac.followNotification = (event) => {
            if (!event.defaultPrevented) {
              $rootScope.goToNegotiation($scope.ac.notification);
              $toast.hide();
            }
          };
        }]

      const extractError = (response, defaultText) => {
        if (response && response.message) {
          return response.message;
        }

        if (response && response.data && response.data.message) {
          return response.data.message;
        }

        if (response && response.validationErrors) {
          for (const propName in response.validationErrors) {
            if (response.validationErrors.hasOwnProperty(propName)) {
              return response.validationErrors[propName];
            }
          }
        }

        return defaultText || $t('shared.errors.unknown');
      }

    }

    return new AlertServiceProvider();
  };
}